import { render, staticRenderFns } from "./ConsentLayout.vue?vue&type=template&id=4e786d4a"
import script from "./ConsentLayout.vue?vue&type=script&lang=js"
export * from "./ConsentLayout.vue?vue&type=script&lang=js"
import style0 from "./ConsentLayout.vue?vue&type=style&index=0&id=4e786d4a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports